import React from 'react';
import './LandingPage.css';
import { useNavigate } from 'react-router-dom';

const features = [
  {
    icon: '',
    title: 'Смяна и ремонт на гуми',
    description: 'Професионална смяна и ремонт на гуми за всички видове автомобили.'
  },
  {
    icon: '',
    title: 'Продажба на гуми и джанти',
    description: 'Широк избор от нови и употребявани гуми и джанти на конкурентни цени.'
  },
  {
    icon: '',
    title: 'Хотел',
    description: 'Сигурно съхранение на вашите гуми с нашата услуга за хотел.'
  }
];

function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="landing-modern">
      <section
        className="hero-section"
        style={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url('/banner.webp')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.6,
            zIndex: 0,
            filter: "brightness(0.7)",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 80, 200, 0.25)",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
        <div className="hero-content" style={{ position: "relative", zIndex: 2 }}>
          <div className="hero-text">
            <h1 className="highlight">Сервиз за гуми</h1>
            <p>
              Запазете си час за смяна на гуми лесно и бързо с нашата онлайн система. Изберете удобен ден и час, а ние ще се погрижим за останалото.
            </p>
            <button className="book-btn hero-btn" onClick={() => navigate('/book')}>
              Запазете час
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2>Нашите услуги</h2>
        <div className="features-list">
          {features.map((feature, idx) => (
            <div className="feature-card" key={idx}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
